import React from 'react';
import { Tag as ChakraTag, TagProps as ChakraTagProps } from '@chakra-ui/react';
import { TagLabel as ChakraTagLabel, TagLabelProps as ChakraTagLabelProps } from '@chakra-ui/react';

export function Tag(props: ChakraTagProps) {
  return <ChakraTag {...props} />;
}

export function TagLabel(props: ChakraTagLabelProps) {
  return <ChakraTagLabel {...props} />;
}
